import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import Toaster from 'v-toaster'
import 'v-toaster/dist/v-toaster.css'
import './assets/theme.scss'
import '/store/auth'; // Path to your auth.js file
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
// optional set default imeout, the default is 10000 (10 seconds).
Vue.use(Toaster, {timeout: 5000})

import axios from 'axios';
import VueAxios from 'vue-axios';
Vue.use(VueAxios, axios) 

// import Vue from 'vue'
import VueMoment from 'vue-moment'
// import moment from 'moment-timezone'
 
Vue.use(VueMoment);
// import Vue from 'vue';
// import excel from 'vue-excel-export';
 
// Vue.use(excel);

// import VueJsonToCsv from 'vue-json-to-csv';

// Vue.use(VueJsonToCsv);

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
